<template>
  <div class="flex flex-col items-center justify-center h-full">
    
    <template v-if="isLoading">
      <div class="inline-flex items-center">
        <font-awesome-icon :icon="['far', 'spinner']" spin /> 
        <div class="ml-2">Laster, vennligst vent ...</div>
      </div>
    </template>

    <template v-else>
      <div class="text-2xl text-center">
        Hei praksiskoordinator!<br/>
        Velkommen til {{ electionPeriod.name }}
      </div>
      <div class="mt-8 pb-12 flex flex-col xl:flex-row items-center">
        <div class="flex flex-col items-center">
          <button class="btn btn-primary mx-2 w-48 text-center" @click="onPracticePeriodsClick" :disabled="electionPeriod.currentStep !== 2">
          Praksisperioder
          <div class="text-xs text-red-200">{{ practicePeriods.length }} registrert</div>
          </button>
        </div>
        <div class="p-1">
          <font-awesome-icon :icon="['far', 'arrow-right']" class="hidden lg:block" />
          <font-awesome-icon :icon="['far', 'arrow-down']" class="lg:hidden" />
        </div>
        <div class="flex flex-col items-center">
          <button class="btn btn-primary mx-2 w-48 text-center" @click="onStudentsClick" :disabled="!isSupervising && electionPeriod.currentStep !== 4 && electionPeriod.currentStep !== 5">
          Studenter <span v-if="isSupervising">*</span>
          <div class="text-xs text-red-200">{{ totalStudentCount > 0 ? totalStudentCount : 'Ingen' }} registrert</div>
          </button>
        </div>
        <div class="p-1">
          <font-awesome-icon :icon="['far', 'arrow-right']" class="hidden lg:block" />
          <font-awesome-icon :icon="['far', 'arrow-down']" class="lg:hidden" />
        </div>
        <div class="flex flex-col items-center">
          <button class="btn btn-primary mx-2 w-48 text-center" @click="onSpecialClick" :disabled="electionPeriod.currentStep !== 5">
          Særplasser
          <div class="text-xs text-red-200">{{ practiceSlotsSpecial.length > 0 ? practiceSlotsSpecial.length : 'Ingen' }} registrert</div>
          </button>
        </div>
        <div class="p-1">
          <font-awesome-icon :icon="['far', 'arrow-right']" class="hidden lg:block" />
          <font-awesome-icon :icon="['far', 'arrow-down']" class="lg:hidden" />
        </div>
        <div class="flex flex-col items-center">
          <button class="btn btn-primary mx-2 w-48 text-center" @click="onWishesClick" :disabled="electionPeriod.currentStep < 5">
          Ønskelister
          <div class="text-xs text-red-200">{{ studentsWithWishesCount }}/{{ totalStudentCount }} registrert</div>
          </button>
        </div>
        <div class="p-1">
          <font-awesome-icon :icon="['far', 'arrow-right']" class="hidden lg:block" />
          <font-awesome-icon :icon="['far', 'arrow-down']" class="lg:hidden" />
        </div>
        <div class="flex flex-col items-center">
          <button class="btn btn-primary mx-2 w-48 text-center" @click="onResultsClick" :disabled="electionPeriod.currentStep !== 7">
          Resultater
          <div class="text-xs text-red-200">{{ practiceSlots.length > 0 ? "Klare!" : 'Ikke klare' }}</div>
          </button>
        </div>
      </div>
      <div class="text-sm" v-if="isSupervising">
      * I veiledermodus kan du registrere og etterregistrere studenter i hele valgperioden.
      </div>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import _ from 'lodash'
export default {
  name: 'pk-home',
  data() {
    return {
      electionPeriod: null,
      practicePeriods: [],
      practiceSlotsSpecial: [],
      practiceSlots: [],
      wishes: [],
      isLoading: false
    }
  },
  computed: {
    isSupervising () {
      return this.$store.getters.user ? this.$store.getters.user.isSupervising : false
    },
    totalStudentCount () {
      return _.sumBy(this.practicePeriods, p => p.studentCount)
    },
    studentsWithWishesCount () {
      return _.filter(this.students, w => w.wishes.length > 0).length
    }    
  },
  methods: {
    onPracticePeriodsClick () {
      this.$router.push({ name: 'pk-practiceperiod-list'})
    },
    onStudentsClick () {
      this.$router.push({ name: 'pk-students-list'})
    },
    onSpecialClick () {
      this.$router.push({ name: 'pk-special-list'})
    },
    onResultsClick () {
      this.$router.push({ name: 'pk-students-results' })
    },
    onWishesClick () {
      this.$router.push({ name: 'pk-wishes' })
    }
  },
  async created () {

    this.isLoading = true

    const [
      electionPeriod,
      practicePeriods,
      practiceSlotsSpecial,
      practiceSlots,
      students
    ] = await Promise.all([
      api.pk.getElectionPeriod(),
      api.pk.getPracticePeriods(),
      api.pk.getPracticeSlotsSpecial(),
      api.pk.getPracticeSlots(),
      api.pk.getWishes()
    ])

    this.electionPeriod = electionPeriod
    this.practicePeriods = practicePeriods
    this.practiceSlotsSpecial = practiceSlotsSpecial
    this.practiceSlots = practiceSlots
    this.students = students

    this.isLoading = false
    
  }
}
</script>
